import { Component, Inject } from '@angular/core';
import {
  MAT_DIALOG_DATA, MatDialog,
  MatDialogConfig, MatDialogRef
} from '@angular/material/dialog';
import { Router } from '@angular/router';

export interface CampaignsForResponseDialogData {
  tag: {
    id: string;
    name: string;
    category: {
      name: string;
      groupName: string;
    };
    targetType: {
      __typename?: string;
      id: string;
    };
  };
}

@Component({
  selector: 'app-campaigns-for-response-dialog',
  template: `
<app-modal>
  <h1 class="h2">Campaigns using this response:</h1>
  <p class="modal-intro mt-0050 mb-0050">
    <span class="d-inline-block modal-breadcrumbs">
      {{tag.category.groupName}} &rsaquo; {{tag.category.name}} &rsaquo; <strong>{{tag.name}}</strong>
    </span>
  </p>
  <p class="modal-intro mt-0050 mb-0150">
    Listed below are all campaigns belonging to your organization. Those that
have the “{{tag.name}}” response active are marked with a check. Click on a
campaign to be directed to the “Info” page for that campaign.
   </p>
   <app-campaign-visibility-filter
   [objectType]="'Tag'"
   [objectTypeId]="tag.id"
   (itemSelected)="itemSelected($event)"
   ></app-campaign-visibility-filter>
</app-modal>
`
})

export class CampaignsForResponseDialog {
  tag = this.data?.tag;

  static open(dialog: MatDialog, config: MatDialogConfig<CampaignsForResponseDialogData>) {
    return dialog.open(CampaignsForResponseDialog, config);
  }

  constructor(
    private router: Router,
    public dialogRef: MatDialogRef<CampaignsForResponseDialog>,
    @Inject(MAT_DIALOG_DATA) public data: CampaignsForResponseDialogData) { }

  close() {
    this.dialogRef.close();
  }

  /** */
  itemSelected(item: { campaignId: string }) {
    const queryParams = {
      campaignId: item.campaignId,
      editMode: true,
      connectionTypeId: null,
      entityTypeId: null,
    };

    const tt = this.tag?.targetType?.__typename;
    if (tt === 'EntityConnectionType') {
      queryParams.connectionTypeId = this.tag.targetType?.id;
    }

    if (tt === 'EntityType') {
      queryParams.entityTypeId = this.tag.targetType?.id;
    }

    this.close();
    this.router.navigate(['/campaign/customize/fields'], { queryParams });
  }

}
